module.exports = "/_next/static/images/8b11ce421d3e4801c4c2a46946a79789-value-proposal-xs-2x.png.webp";